import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logOut } from '../../features/auth/authSlice'
import { BASE_URL } from '../../features/auth/authApiSlice'

const baseQuery = fetchBaseQuery({
    baseUrl: '',
    //   credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.pbitoken
        if (token) {
            headers.set("authorization", `Bearer ${token}`)
        } else {
            headers.set("enacto", `3066A157-554F-4C7C-ACF7-AAF914E9B7F6`)
        }
        return headers
    }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    // console.log('args', args, api, extraOptions)
    let result = await baseQuery(args, api, extraOptions)
    // console.log('result', result)
    if (result?.error?.originalStatus === 403 || result?.error?.originalStatus === 401) { 
        console.log('sending refresh token')
        // send refresh token to get new access token
        // let userName = api.getState().auth.user
        // console.log('username-', userName)
        let baseUrl = `${BASE_URL}/authentication/RefreshPowerBiToken`
        let refreshArgs = {
            url: `${baseUrl}`, ///RefreshToken?username=${userName}
            method: 'GET'
        }
        // console.log('args->', refreshArgs, api, extraOptions)
        const refreshResult = await baseQuery(refreshArgs, api, extraOptions)
        // console.log('refreshtoken-', refreshResult)
        if (refreshResult?.data) {
            const user = api.getState().auth.user
            // store the new token 
            let Token = refreshResult && refreshResult.data && refreshResult.data.token;
            api.dispatch(setCredentials({ 'Token': Token, user }))
            // retry the original query with new access token 
            result = await baseQuery(args, api, extraOptions)
        } else {
            api.dispatch(logOut())
        }
    }

    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})